<template>
  <div class="game-row" :class="{ night }" @click="goBet">
    <img class="game-icon" :src="game.icon" :alt="game.name" />
    <div class="game-main">
      <div class="game-title">{{ game.name }}</div>
      <div v-if="game.badge" class="game-badge" :class="badgeClass">
        <span>{{ game.badge }}</span>
        <img v-if="showArrow" class="badge-arrow" :src="recArrow" alt="" />
      </div>
    </div>
    <div class="game-mid">
      <div class="game-period">{{ game.period }}</div>
    </div>
    <div class="game-side">
      <div class="small-icons">
        <span v-if="!game.hot && !game.isNew" class="empty-icon" aria-hidden="true" />
        <span v-if="game.isNew" class="flag new">新</span>
        <span v-if="game.hot" class="flag hot">热</span>
        <HeartBtn
          :active="!!game.fav"
          :shift-x="showPlayers ? 0 : 0"
          @toggle="onToggleFav"
        />
      </div>
      <div v-if="showPlayers && game.players" class="current-account-user">
        <div class="align-right">{{ formatWan(game.players) }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import HeartBtn from '@/components/HeartBtn.vue'
import { useTheme } from '@/composables/useTheme'
import { setActiveGame } from '@/composables/useActiveGame'
import { getBetPath } from '@/composables/betRoute'
import { toggleFav } from '@/data/games'
import recArrow from '@/assets/lobby/ui/rec-arrow.svg'

const props = defineProps({
  game: { type: Object, required: true },
  showPlayers: { type: Boolean, default: true }
})

const { night } = useTheme()
const router = useRouter()

const onToggleFav = () => {
  toggleFav(props.game)
}

const goBet = () => {
  setActiveGame(props.game.id)
  router.push({ path: getBetPath(props.game.id), query: { id: props.game.id } })
}

const badgeClass = computed(() => {
  const badge = props.game.badge
  if (badge === '中奖推荐排行') return 'rank'
  if (badge === '热门销量彩票') return 'sale'
  if (badge === '新增彩票') return 'new'
  return ''
})

const showArrow = computed(() => !!props.game.badge)

const formatWan = (n) => {
  if (n >= 10000) {
    const wan = (n / 10000).toFixed(2).replace(/\.?0+$/, '')
    return `${wan} 万人`
  }
  return `${n} 人`
}
</script>

<style scoped>
.game-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 2px;
  cursor: pointer;
}

.game-icon {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}

.game-main {
  width: 108px;
  flex-shrink: 0;
  min-width: 0;
}

.game-title {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: #222;
}

.game-badge {
  display: inline-flex;
  align-items: center;
  gap: 1px;
  margin-top: 5px;
  max-width: 100%;
  height: 16px;
  padding: 0 8px 0 2px;
  border-radius: 3px;
  background: linear-gradient(115deg, #f5c4a8, #fbdbcb);
  clip-path: polygon(100% 60%, calc(100% - 7px) 100%, 0 100%, 0 0, 100% 0);
  color: #464646;
  font-size: 10px;
  line-height: 16px;
  white-space: nowrap;
}

.badge-arrow {
  width: 11px;
  height: 11px;
  flex-shrink: 0;
}

.game-badge.rank {
  background: linear-gradient(115deg, #f5c4a8, #fbdbcb);
  color: #464646;
}

.game-badge.sale,
.game-badge.new {
  background: linear-gradient(115deg, #f5c4a8, #fbdbcb);
  color: #464646;
}

.game-mid {
  flex: 1;
  min-width: 0;
  text-align: left;
  padding-left: 4px;
}

.game-period {
  font-size: 12px;
  color: #929292;
}

.game-side {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  min-width: 0;
}

.small-icons {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.empty-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.flag {
  width: 18px;
  height: 18px;
  border-radius: 3px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  flex-shrink: 0;
}

.flag.hot {
  background: #ff5b5b;
}

.flag.new {
  background: #56befc;
}

.current-account-user {
  flex-shrink: 0;
  margin-left: 4px;
}

.align-right {
  font-size: 12px;
  color: #929292;
  white-space: nowrap;
  line-height: 1;
}

.game-row.night .game-title {
  color: #fff;
}

.game-row.night .game-period,
.game-row.night .align-right {
  color: #a6a6a6;
}
</style>
